<template>
  <div class="deal-wheel">
    <div class="spinner-wrapper"></div>
    <ul ref="spinner" class="spinner" :style="spinnerStyle" @transitionend="handlerTransitionEnd">
      <li
        v-for="(prize, i) in prizes"
        :key="i"
        :data-reaction="prize.reaction"
        :style="`--rotate: ${prizeSlice * i * -1 - prizeOffset}deg`"
        class="prize"
        :class="{ selected: selectedItem == i }"
      >
        <span class="text">{{ prize.name }}</span>
      </li>
    </ul>
    <div ref="ticker" class="ticker">
      <img src="/local/templates/love-you/images/wheel/сердце.png" alt="heart" />
    </div>
  </div>
</template>

<script>
/** documentation https://thecode.media/fortune/ * */

export default {
  name: 'DealWheel',
  props: ['prizes'],
  data() {
    return {
      // colors: [
      //   'hsl(197 30% 43%)',
      //   'hsl(173 58% 39%)',
      //   'hsl(43 74% 66%)',
      //   'hsl(27 87% 67%)',
      //   'hsl(12 76% 61%)',
      //   'hsl(350 60% 52%)',
      //   'hsl(91 43% 54%)',
      //   'hsl(140 36% 74%)',
      // ],
      // прописываем CSS-классы, которые будем добавлять и убирать из стилей
      spinClass: 'is-spinning',
      // получаем все значения параметров стилей у секторов
      spinnerStyles: {},
      // переменная для анимации⠀
      tickerAnim: null,
      // угол вращения
      rotation: 0,
      // текущий сектор⠀
      currentSlice: 0,

      // selected item
      selectedItem: null,

      numberOfPrize: 0,
    };
  },
  computed: {
    // на сколько секторов нарезаем круг
    prizeSlice() {
      return 360 / this.prizes?.length;
    },
    // на какое расстояние смещаем сектора друг относительно друга
    prizeOffset() {
      return Math.floor(180 / this.prizes?.length);
    },
    spinnerStyle() {
      try {
        // return `background: conic-gradient(from -90deg, ${ this.prizes.map(({ color }, i) => `${this.colors[ i ]} 0 ${(100 / this.prizes.length) * (this.prizes.length - i)}%`).reverse()});`;
        return `background: conic-gradient(from -90deg, ${this.prizes
          .map(
            ({ color }, i) =>
              `${i % 2 ? '#feeae3' : '#c9e6f8'} 0 ${
                (100 / this.prizes.length) * (this.prizes.length - i)
              }%`
          )
          .reverse()});`;
      } catch (err) {
        console.error(err);
      }
    },
  },
  mounted() {
    this.spinnerStyles = window.getComputedStyle(this.$refs.spinner);
  },
  methods: {
    // функция запуска вращения с плавной остановкой
    spinertia(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    // функция запуска вращения с плавной остановкой
    runTickerAnimation() {
      try {
        // взяли код анимации отсюда: https://css-tricks.com/get-value-of-css-rotation-through-javascript/
        const values = this.spinnerStyles.transform.split('(')[1].split(')')[0].split(',');
        const a = values[0];
        const b = values[1];
        let rad = Math.atan2(b, a);

        if (rad < 0) rad += 2 * Math.PI;

        const angle = Math.round(rad * (180 / Math.PI));
        const slice = Math.floor(angle / this.prizeSlice);

        // анимация язычка, когда его задевает колесо при вращении
        // если появился новый сектор
        if (this.currentSlice !== slice) {
          // убираем анимацию язычка
          this.$refs.ticker.style.animation = 'none';

          // и через 10 миллисекунд отменяем это, чтобы он вернулся в первоначальное положение
          setTimeout(() => (this.$refs.ticker.style.animation = null), 10);
          // после того как язычок прошёл сектор — делаем его текущим
          this.currentSlice = slice;
        }
        // запускаем анимацию
        this.tickerAnim = requestAnimationFrame(this.runTickerAnimation);
      } catch (err) {
        console.error(err);
      }
    },
    handlerTriggerClick(button) {
      try {
        // делаем её недоступной для нажатия
        button.disabled = true;
        // задаём начальное вращение колеса
        this.rotation =
          (360 / this.prizes.length) * this.numberOfPrize -
          this.spinertia(1, 360 / this.prizes.length - 1) +
          360 * Math.ceil(Math.random() * 10);
        // убираем прошлый приз
        this.selectedItem = null;
        // добавляем колесу класс is-spinning, с помощью которого реализуем нужную отрисовку
        this.$el.classList.add(this.spinClass);
        // через CSS говорим секторам, как им повернуться
        this.$refs.spinner.style.setProperty('--rotate', this.rotation);
        // возвращаем язычок в горизонтальную позицию
        this.$refs.ticker.style.animation = 'none';
        // запускаем анимацию вращение
        this.runTickerAnimation();
      } catch (err) {
        console.error(err);
      }
    },
    handlerTransitionEnd() {
      // останавливаем отрисовку вращения
      cancelAnimationFrame(this.tickerAnim);
      // получаем текущее значение поворота колеса
      this.rotation %= 360;
      // выбираем приз
      this.selectPrize();
      // убираем класс, который отвечает за вращение
      this.$el.classList.remove(this.spinClass);
      // отправляем в CSS новое положение поворота колеса
      this.$refs.spinner.style.setProperty('--rotate', this.rotation);
      // делаем кнопку снова активной
      this.$emit('transitionEnd');
    },
    selectPrize() {
      const selected = Math.floor(this.rotation / this.prizeSlice);
      this.selectedItem = selected;
    },
  },
};
</script>

<style lang="scss" scoped>
/* общий блок для всех элементов */
.deal-wheel {
  justify-self: center;
  padding: 15px 15px 15px 30px;
  overflow: hidden;
  /* задаём переменные блока, внутри которого всё будет рисоваться */
  /* размеры колеса */
  --size: clamp(250px, 80vmin, 400px);
  //--size: 300px;
  /* clamp — функция CSS, которая задаёт три размера: минимальное, предпочтительное и максимальное. В данном случае мы хотим, чтобы колесо было не меньше 250 пикселей, не больше 700 пикселей, но в идеале — 80% от безопасно малой высоты окна браузера */
  /* настройки яркости и заливки фона секторов. Нам понадобится описать поведение градиента, это у нас делается через много переменных */
  --lg-hs: 0 3%;
  --lg-stop: 50%;
  --lg: linear-gradient(
    hsl(var(--lg-hs) 0%) 0 var(--lg-stop),
    hsl(var(--lg-hs) 20%) var(--lg-stop) 100%
  );
  /* добавляем позиционирование относительно других элементов */
  position: relative;
  /* подключаем стандартную CSS-сетку */
  display: grid;
  grid-gap: calc(var(--size) / 20);
  /* выравниваем содержимое блока по центру */
  align-items: center;
  /* задаём имена областей внутри сетки — в CSS теперь можно прямо назвать эти области */
  grid-template-areas: 'spinner';
  //"trigger";
  /* устанавливаем размер шрифта */
  font-size: calc(var(--size) / 21);
  /* розвертаємо колесо фортуни на 90deg */
  transform: rotate(90deg);

  /* всё, что относится ко внутренним элементам главного блока, будет находиться в области сетки с названием spinner */
  & > * {
    grid-area: spinner;
  }

  /* сектор колеса */
  .spinner {
    /* добавляем относительное позиционирование */
    position: relative;
    /* подключаем сетку */
    display: grid;
    /* выравниваем всё по центру */
    align-items: center;
    /* добавляем элемент в сетку */
    grid-template-areas: 'spinner';
    /* устанавливаем размеры */
    width: var(--size);
    height: var(--size);
    /* поворачиваем элемент  */
    transform: rotate(calc(var(--rotate, 25) * 1deg));
    /* рисуем круглую обводку, а всё, что не поместится, — будет скрыто за кругом */
    border-radius: 50%;

    //box-shadow: 0px 0px 10px RGB(128 110 70);

    &:after {
      content: '';
      position: absolute;
      width: 35px;
      height: 35px;
      //background-color: black;
      //top: 0px;
      //bottom: 0px;
      //left: 0px;
      //right: 0px;
      //background: radial-gradient(rgba(255, 255, 255, 0.4) 10%, transparent 30%, transparent);
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      background-color: #628eab;
      border: 5px solid #fff;
    }
  }
  /* всё, что внутри этого блока, будет находиться в области сетки с названием spinner */
  .spinner * {
    grid-area: spinner;
  }

  .prize {
    /* включаем «гибкую» вёрстку */
    display: flex;
    align-items: center;
    justify-content: center;
    /* задаём отступы от краёв блока */
    padding: 0 calc(var(--size) / 6) 0 calc(var(--size) / 20);
    /* устанавливаем размеры */
    width: 50%;
    height: 50%;
    /* устанавливаем координаты, относительно которых будем вращать текст */
    transform-origin: center right;
    /* поворачиваем текст */
    transform: rotate(var(--rotate));
    /* запрещаем пользователю выделять мышкой текст на секторах */
    user-select: none;

    //writing-mode: vertical-rl;
    position: relative;

    span {
      max-width: 100px;
      //max-height: 60px;
      //text-align: center;
      //padding: 5px;
      //@include point-md {
      //  max-height: 100px;
      //}
    }

    &:nth-child(2n) {
      //color: #e70946;
      color: #5d8093;
    }

    &:nth-child(2n - 1) {
      color: #5d8093;
      //color: var(--border-colour-primary);
      //&:before {
      //  content: '';
      //  display: block;
      //  position: absolute;
      //  top: 50%;
      //  transform: rotate(90deg) translate(-50%, 0);
      //  width: 100px;
      //  height: 100px;
      //  background-image: url('/local/templates/love-you/images/wheel/подарунок.png');
      //  background-position: center center;
      //  background-repeat: no-repeat;
      //  background-size: contain;
      //  transform-origin: center;
      //  z-index: -1;
      //}
    }
  }
}

/* язычок */
.ticker {
  display: flex;
  align-items: center;
  /* добавляем относительное позиционирование */
  position: relative;
  /* устанавливаем размеры */
  left: calc(var(--size) / -15);
  width: calc(var(--size) / 10);
  height: calc(var(--size) / 20);
  /* фон язычка */
  //background: #daa068;
  /* делаем так, чтобы язычок был выше колеса */
  z-index: 1;
  /* форма язычка */
  //clip-path: polygon(20% 0, 100% 50%, 20% 100%, 0% 50%);
  /* устанавливаем точку, относительно которой будет вращаться язычок при движении колеса */
  //transform-origin: center left;

  img {
    transform: rotate(-90deg);
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    @include point-md {
      width: 36px;
      height: 36px;
    }
  }
}
/* анимация вращения */
.is-spinning .spinner {
  transition: transform 8s cubic-bezier(0.1, -0.01, 0, 1);
}

/* анимация движения язычка */
.is-spinning .ticker {
  animation: tick 700ms cubic-bezier(0.34, 1.56, 0.64, 1);
}

/* эффект, когда колесо задевает язычок при вращении */
@keyframes tick {
  40% {
    /* чуть поворачиваем язычок наверх в середине анимации */
    transform: rotate(-12deg);
  }
}

/* анимируем выпавший сектор */
.prize.selected .text {
  /* делаем текст белым */
  color: #c3a81e;
  /* настраиваем длительность анимации */
  animation: selected 800ms ease;
}

/* настраиваем анимацию текста на выпавшем секторе по кадрам */
@keyframes selected {
  /* что происходит на 25% от начала анимации */
  25% {
    /* увеличиваем текст в 1,25 раза */
    transform: scale(1.25);
    /* добавляем тексту тень */
    text-shadow: 1vmin 1vmin 0 HSLA(0 0% 0% / 0.1);
  }
  40% {
    transform: scale(0.92);
    text-shadow: 0 0 0 HSLA(0 0% 0% / 0.2);
  }
  60% {
    transform: scale(1.02);
    text-shadow: 0.5vmin 0.5vmin 0 HSLA(0 0% 0% / 0.1);
  }
  75% {
    transform: scale(0.98);
  }
  85% {
    transform: scale(1);
  }
}
.spinner-wrapper {
  border-radius: 50%;
  //padding: 10px;
  //background: conic-gradient(#FCFBA1, #9C6E23, #FBE06F, #FFF385, #FAE977, #A2762B, #3D3D3D, #B47C31, #FBE777, #FCFBA1);

  //padding: 20px;
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  background-color: #fff;
  //background: url('/local/templates/love-you/images/wheel.png');
  //background-position: center;
  //background-size: 100%;
  //background-repeat: no-repeat;
  //@include point-md {
  //  top: -20px;
  //  left: -20px;
  //  right: -20px;
  //  bottom: -20px;
  //}
}
</style>
